module.exports = __webpack_public_path__ + "img/bubble-teacher.a0a167d9.webp";